// extracted by mini-css-extract-plugin
module.exports = {"submit":"ShellChangePassword_submit__krigW","formSection":"ShellChangePassword_formSection__2voYd"};